import { render, staticRenderFns } from "./ProductReturnDetail.vue?vue&type=template&id=30d8b2cc&"
import script from "./ProductReturnDetail.vue?vue&type=script&lang=js&"
export * from "./ProductReturnDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductReturnDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports